module.exports = __webpack_public_path__ + "media/images/meta/akt/apple-touch-icon-4a0eece12c0ecc4c68387c7725cf063d.png";